import { render, staticRenderFns } from "./DocumentExtraFieldsPortcallForm.vue?vue&type=template&id=c63e8720&scoped=true"
import script from "./DocumentExtraFieldsPortcallForm.vue?vue&type=script&lang=js"
export * from "./DocumentExtraFieldsPortcallForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentExtraFieldsPortcallForm.vue?vue&type=style&index=0&id=c63e8720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63e8720",
  null
  
)

export default component.exports